import React from "react";
import close_button from "../../../assets/images/rewards/close_button.png";
import { Box } from "@mui/material";

//Componente botão de fechar o modal de conquistas
const ButtonCloseReward = ({ closeReward }) => {

  return (
    <Box
      type="button"
      id="closeButton"
      onClick={() => {
        closeReward();
      }}
      sx={{
        display: "block",
        transform: "scale(0.0, 0.0)",
        webkitTransition: "all 0.5s ease",
        mozTransition: "all 0.5s ease",
        oTransition: "all 0.5s ease",
        msTransition: "all 0.5s ease",
        transition: "all 0.5s ease",
        margin: "auto",
        cursor: "pointer",
        width: "10%",
        maxWidth: "80px",
        position: "fixed",
        top: "20px",
        right: "20%",

        "&:hover": {
          transform: "scale(1.1, 1.1) !important ",
        },
      }}
    >
      <img src={close_button} alt="close" title="close" />
    </Box>
  );
};

export default ButtonCloseReward;
